module.exports = __webpack_public_path__ + "img/Artboard 6.634b9416.png";